import axios from "axios";
import qs from "qs";
import { loadConfig } from "./config";

let baseUrlPromise;

const normalizeBase = (url = "") => url.replace(/\/+$/, "");

const resolveBaseUrl = async () => {
  if (!baseUrlPromise) {
    baseUrlPromise = loadConfig().then((config) => {
      const raw = config?.apiURL;
      if (!raw) throw new Error("apiURL is not defined in setting.json");
      return `${normalizeBase(raw)}/kiddo`;
    });
  }
  return baseUrlPromise;
};

export const getKiddoBaseUrl = resolveBaseUrl;

export const createKiddoAxios = async (axiosConfig = {}) => {
  const baseURL = await resolveBaseUrl();
  const config = {
    baseURL,
    ...axiosConfig,
  };

  if (!config.paramsSerializer) {
    config.paramsSerializer = (params) =>
      qs.stringify(params, { arrayFormat: "repeat", skipNulls: true });
  }

  return axios.create(config);
};

let sharedClientPromise;
export const getSharedKiddoAxios = async (axiosConfig = {}) => {
  if (!sharedClientPromise) {
    sharedClientPromise = createKiddoAxios(axiosConfig);
  }
  return sharedClientPromise;
};
